import echarts from 'echarts';
export default {
    name: 'Chartsd',
    props: {
        chartData: {
        }
    },
    data() {
        return {
            chart1: null,
            myid: this.$getRandom(10),
            charttitle:{}
        };
    },
    methods: {
        // 用于初始化一些数据
        init() {

            window.onresize = () => {
                if (this.chart1) {
                    this.chart1.resize();
                }
            }
            this.charttitle=this.chartData.text;

        },
        getTableLine(num) {
            var list = [];
            var bottom = 122;
            var height = 20;
            for (var i = 0; i < num; i++) {
                list.push({
                    type: 'line',
                    bottom: bottom - i * height,
                    right: 80,
                    style: {
                        fill: '#333'
                    },
                    shape: {
                        x1: 0,
                        y1: 0,
                        x2: 3200,
                        y2: 0
                    }

                });
            }
            return list;
        }, 
        formatNumberInt(num, prec, ceil)
         {
            const len = String(num).length;
            if (len <= prec) { return num };

            const mult = Math.pow(10, prec);
            return ceil ?
                Math.ceil(num / mult) * mult :
                Math.floor(num / mult) * mult;
        },
        async init1() {
            this.chart1 = echarts.init(document.getElementById(this.myid));

            var chartList = this.chartData;

            var data = {
                title: chartList.xtitle,
                zhuzhuangtu:chartList.zhuzhuangdata,
                zhuzhuangtutitle:chartList.zhuzhuangdatatitle,
                zhexiantu1: chartList.zhexiandata1,
                zhexiantutitle1:chartList.zhexiandatatitle1,
                zhexiantu2: chartList.zhexiandata2,
                zhexiantutitle2:chartList.zhexiandatatitle2,
                colorlist:chartList.colorlist

            };

            // for (var pr in data) {
            //     data[pr] = data[pr].slice(1, -1);
            // }
            var titletext="";
            var tinum=0;
            chartList.xzhou.forEach(function (item) { 

                if(tinum==0)
                {
                    titletext=item
                }
                else
                {
                    titletext+='\n' + item;
                }
                tinum++;

            });
            
            var lineList = this.getTableLine(4);

            // 绘制图表
            this.chart1.setOption({
                title: [
                    {
                    text:titletext,
                    bottom: 56,
                    left: 10,
                    textStyle: {
                        lineHeight: 20,
                        fontSize: 13,
                        fontWeight: 'normal',
                        formatter: function (value) {
                            return '{table|' + value + '}';
                        },
                        rich: {
                            table: {
                                align: 'center'
                            }
                        }
                    }
                }
            ],
                tooltip: {
                    trigger: 'axis',
                    axisPointer: {
                        type: 'cross',
                        label: {
                            backgroundColor: '#283b56'
                        }
                    }
                },
                legend: {
                    data: chartList.xzhou
                },
                grid: {
                    bottom: 150,
                    left: 80,
                    right: 80
                },
                toolbox: {
                    show: true,
                    feature: {
                        saveAsImage: {}
                    }
                },
                dataZoom: {
                    show: false,
                    start: 0,
                    end: 100,
                    maxSpan: 100
                    // zoomLock: true
                },
                xAxis: [{
                    type: 'category',
                    boundaryGap: true,
                    data: data.title,
                    axisTick: {
                        length: 88
                    },
                    axisLabel: {
                        showMaxLabel: true,
                        interval: 0,
                        formatter: function (value, index) {
                            var indexNum = 0;
                            for (var i = 0; i < data.title.length; i++) {
                                if (value == data.title[i]) {
                                    indexNum = i;
                                }
                            }
                            return '{table|' + value +
                                '}\n{table|' + data.zhuzhuangtutitle[indexNum] +
                                '}\n{table|' + data.zhexiantutitle1[indexNum] +
                                '%}\n{table|' + data.zhexiantutitle2[indexNum] +
                                '%}';
                        },
                        rich: {
                            table: {
                                lineHeight: 20,
                                align: 'center',
                            }
                        }
                    }
                }],
                yAxis: [
                    {
                        type: 'value',
                        minInterval: 1,
                        min: 0,
                    },
                    {
                        type: 'value',
                        splitLine: {
                            show: false
                        },
                        min: function (v) {
                            var val= Math.floor(v.min);
                            if(val>0){
                                if(val<10){
                                    return 0;
                                }
                                else{
                                    return parseInt((v.min+"").slice(0,1))*10
                                }
                            }
                            else
                            {
                                if(val>-10){
                                    return -10;
                                }
                                else if(val>-100)
                                {
                                    var el=Math.abs(val) 
                                    return  0-(parseInt((el+"").slice(0,1))+2)*10;

                                }
                                else{
                                    return parseInt(val-100);
                                }


                            }
                            
                        },
                        axisLabel: {
                            formatter: '{value} %'
                        }
                    }],
                series: [
                 {
                    name: chartList.xzhou[0],
                    type: 'bar',
                    label: {
                        show: true,
                        position: 'top'
                    }, 
                    textStyle:{
                        color:"#fff", //刻度颜色
                        fontSize:14,  //刻度大小
                   },
                    yAxisIndex: 0,
                    data: data.zhuzhuangtu, 
                    itemStyle: {
                        //通常情况下：
                        normal: {
                            //每个柱子的颜色即为colorList数组里的每一项，如果柱子数目多于colorList的长度，则柱子颜色循环使用该数组
                            color: function (params) { 
                                return data.colorlist[params.dataIndex];
                            }
                        },
                        //鼠标悬停时：
                        emphasis: {
                            shadowBlur: 10,
                            shadowOffsetX: 0,
                            shadowColor: 'rgba(0, 0, 0, 0.5)'
                        }
                    } 
                },
                {
                    name:chartList.xzhou[1],
                    type: 'line',
                    label: {
                        show: true,
                        position: 'top',
                        formatter: '{c} %'
                    },
                    yAxisIndex: 1,
                    data: data.zhexiantu1,
                },
                {
                    name:chartList.xzhou[2],
                    type: 'line',
                    label: {
                        show: true,
                        position: 'top',
                        formatter: '{c} %'
                    },
                    yAxisIndex: 1,
                    data: data.zhexiantu2
                }],
                graphic: lineList
            })

        },

        // 用于更新一些数据
        update() { },
    },
    // 计算属性
    computed: {
    },
    // 包含 Vue 实例可用过滤器的哈希表。
    filters: {},
    // 在实例创建完成后被立即调用
    created() { },
    // 在挂载开始之前被调用：相关的 render 函数首次被调用。
    beforeMount() { },
    // el 被新创建的 vm.el 替换，并挂载到实例上去之后调用该钩子。
    mounted() {
    },
    // 数据更新时调用，发生在虚拟 DOM 打补丁之前。
    beforeUpdate() { },
    // keep-alive 组件激活时调用。
    activated() { },
    // keep-alive 组件停用时调用。
    deactivated() { },
    // 实例销毁之前调用。在这一步，实例仍然完全可用。
    beforeDestroy() { },
    //Vue 实例销毁后调用。
    destroyed() { },
    // 当捕获一个来自子孙组件的错误时被调用。
    errorCaptured() { },
    // 包含 Vue 实例可用指令的哈希表。
    directives: {},
    // 一个对象，键是需要观察的表达式，值是对应回调函数。
    watch: {
        chartData() {
            this.init1();
            this.$nextTick(() => {
                this.init();
            });
        }
    },
    // 组件列表
    components: {},
};